import Data from 'models/DataModel';
import { extractFilenameFromAttachmentUrl } from 'utils/fileUtilities';

type DataUpdater = (current: Data) => Data;

const safeUrl = (value: string): URL | null => {
  try {
    return new URL(value);
  } catch {
    return null;
  }
};

const getFilenameStem = (filename: string): string => {
  const lastDot = filename.lastIndexOf('.');
  return lastDot > 0 ? filename.slice(0, lastDot) : filename;
};

export const deleteAttachmentFromData =
  (attachmentUri: string) =>
  (data: Data): Data => {
    const existing = data.Attachments ?? [];

    if (!existing.includes(attachmentUri)) {
      return data;
    }

    return {
      ...data,
      Attachments: existing.filter((uri) => uri !== attachmentUri)
    };
  };

const isQuestionAttachment = (questionId: string, attachmentUrl: string): boolean => {
  const url = safeUrl(attachmentUrl);
  if (!url) return false;

  const filename = extractFilenameFromAttachmentUrl(url);
  return getFilenameStem(filename) === questionId;
};

export const replaceQuestionAttachmentInData =
  (questionId: string, newAttachmentUri: string): DataUpdater =>
  (current: Data): Data => {
    const attachments = current.Attachments ?? [];
    const filtered = attachments.filter((a) => !isQuestionAttachment(questionId, a));

    if (filtered.includes(newAttachmentUri)) {
      return filtered.length === attachments.length ? current : { ...current, Attachments: filtered };
    }

    return { ...current, Attachments: [...filtered, newAttachmentUri] };
  };
